import { Button, Dialog, TextField, Toast, Typography } from "@/components/kit";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import useUpdateRoleDetails from "@/hooks/query/acl/useUpdateRoleDetails";
import TextArea from "@/components/kit/TextArea";
import { TrioRole } from "@/hooks/query/acl/useGetRoles";
interface IEditRoleModelProps {
  isOpen: boolean;
  handleClose: () => void;
  role: TrioRole;
}

function editRoleModel({ handleClose, isOpen, role }: IEditRoleModelProps) {
  const [name, setName] = useState<string>(role.name);
  const [description, setDescription] = useState<string>(
    role.description ?? "",
  );
  const { mutate: editRole, isPending } = useUpdateRoleDetails();
  const queryClient = useQueryClient();
  const handleCloseModal = () => {
    setName(role.name);
    setDescription(role.description ?? "");
    handleClose();
  };
  const handleEdit = () => {
    editRole(
      { name, description, currentName: role.name },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ["TrioRoles"] });
          Toast({
            status: "success",
            description: "The role details have been changed.",
            title: "Success",
          });
          handleClose();
        },
      },
    );
  };
  return (
    <Dialog
      body={
        <div className="flex flex-col items-start gap-3 pt-2 pb-8">
          <Typography variant="BodyPlus1-Regular" color="text-gray-800">
            Provide a name for the role
          </Typography>
          <TextField
            value={name}
            onChange={(e) => setName(e.target.value)}
            label="Name"
          />
          <TextArea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            label="Description (optional)"
          />
        </div>
      }
      title={`Edit ${role.name} role`}
      handler={handleCloseModal}
      open={isOpen}
    >
      <Button onClick={handleCloseModal} disabled={false} variant="outlined">
        Cancel
      </Button>
      <Button
        disabled={name.trim() === ""}
        onClick={handleEdit}
        isLoading={isPending}
      >
        Save
      </Button>
    </Dialog>
  );
}

export default editRoleModel;
